import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import RouteLink from "./Route/RouteLink";

function App() {
  return (
    <>
      <RouteLink></RouteLink>
    </>
  );
}

export default App;
